'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { useAuthStore } from '@/stores/authStore';

export function usePermissions() {
  const permissionMap = useAuthStore((state) => state.permissionMap);
  const user = useAuthStore((state) => state.user);

  function hasPermission(permissionName: string): boolean {
    if (!permissionMap || !user?.permissions) return false;

    // Get the permission ID from the permission name
    const permissionId = permissionMap[permissionName];

    if (!permissionId) {
      console.warn(`Permission "${permissionName}" not found in permission map`);
      return false;
    }

    // Check if user has this permission ID
    return user.permissions.includes(permissionId);
  }

  function hasAnyPermission(permissionNames: string[]): boolean {
    return permissionNames.some((permissionName) => hasPermission(permissionName));
  }

  function hasAllPermissions(permissionNames: string[]): boolean {
    return permissionNames.every((permissionName) => hasPermission(permissionName));
  }

  return {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    userPermissions: user?.permissions || [],
    permissionMap,
  };
}
